import styled from 'styled-components';

import { Divider as DividerComponent } from '@xingternal/divider';
import { mediaConfined } from '@xingternal/layout-tokens';
import { scale010, space3XL, spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';

export const Body = styled(BodyCopy)`
  text-align: center;
  margin: 0;

  span {
    font-weight: bold;
  }
`;

export const ProfileHeadline = styled(Headline)`
  margin-bottom: ${spaceS};
  text-align: center;
`;

export const ProfileHeadlineText = styled.span`
  margin-right: ${spaceS};
`;

export const ProfileBody = styled(BodyCopy)`
  text-align: center;
  margin: 0 0 ${spaceS};
`;

export const UpdateProfileCtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spaceXL} 0;
  width: 100%;

  @media ${mediaConfined} {
    margin: ${spaceXXL} 0;
  }
`;

export const Divider = styled(DividerComponent)`
  height: ${scale010};
  width: 100%;
  margin: ${spaceXXL} 0;

  @media ${mediaConfined} {
    margin: ${space3XL};
  }
`;
